import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Form, Input, Modal, Radio, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { getRootStore } from "@/stores/RootStore";
import { DEFAULT_ORDER_CANCEL_INITIATOR, isCancelReasonValid, MIN_CANCEL_REASON_LENGTH, ORDER_CANCEL_INITIATOR_LABELS, } from "@/utils/orderCancel";
import styles from "@/styles/OrderDetail/OrderCancelModal.module.less";
const { Text } = Typography;
const { TextArea } = Input;
/**
 * WP-DSP-FIX-03: отмена заказа с обязательной причиной и инициатором.
 * Диспетчер → «Отменён диспетчером» (DISPATCHER_CANCELLED), клиент → «Отменён» (CANCELLED).
 */
const OrderCancelModal = observer(({ onClose }) => {
    const { singleOrderStore: store, orderDetailStore } = getRootStore();
    const [form] = Form.useForm();
    const [error, setError] = useState(null);
    const reason = Form.useWatch("reason", form);
    const handleConfirm = async () => {
        const values = await form.validateFields();
        setError(null);
        const failure = await store.cancelOrder(values.initiator, values.reason);
        if (failure) {
            setError(failure);
            return;
        }
        // История статусов и зеркало клиента — отдельный стор карточки
        if (store.order)
            void orderDetailStore.refetch(store.order.id);
        onClose();
    };
    return (_jsxs(Modal, { open: true, title: `Отмена заказа #${store.order?.orderNumber ?? ""}`, onCancel: onClose, onOk: handleConfirm, okText: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437", cancelText: "\u041D\u0430\u0437\u0430\u0434", okButtonProps: {
            danger: true,
            loading: store.isCancelling,
            disabled: !isCancelReasonValid(reason),
            "data-testid": "order_cancel__confirm",
        }, destroyOnClose: true, children: [_jsx("div", { className: styles.cancelModal__hint, children: _jsx(Text, { type: "secondary", children: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u043E\u043F\u0430\u0434\u0451\u0442 \u0432 \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432 \u0437\u0430\u043A\u0430\u0437\u0430." }) }), _jsxs(Form, { form: form, layout: "vertical", initialValues: { initiator: DEFAULT_ORDER_CANCEL_INITIATOR, reason: "" }, children: [_jsx(Form.Item, { name: "initiator", label: "\u0418\u043D\u0438\u0446\u0438\u0430\u0442\u043E\u0440 \u043E\u0442\u043C\u0435\u043D\u044B", children: _jsx(Radio.Group, { "data-testid": "order_cancel__initiator", children: Object.keys(ORDER_CANCEL_INITIATOR_LABELS).map((initiator) => (_jsx(Radio, { value: initiator, children: ORDER_CANCEL_INITIATOR_LABELS[initiator] }, initiator))) }) }), _jsx(Form.Item, { name: "reason", label: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430", rules: [
                            {
                                validator: (_, value) => isCancelReasonValid(value)
                                    ? Promise.resolve()
                                    : Promise.reject(new Error(`Укажите причину — не короче ${MIN_CANCEL_REASON_LENGTH} символов`)),
                            },
                        ], children: _jsx(TextArea, { rows: 3, placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u043A\u043B\u0438\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u043D\u0451\u0441 \u0432\u0438\u0437\u0438\u0442, \u0442\u0435\u0445\u043D\u0438\u043A \u043D\u0435 \u0443\u0441\u043F\u0435\u0432\u0430\u0435\u0442", "data-testid": "order_cancel__reason" }) })] }), error ? (_jsx(Alert, { type: "error", showIcon: true, message: error, className: styles.cancelModal__error })) : null] }));
});
OrderCancelModal.displayName = "OrderCancelModal";
export default OrderCancelModal;
